import { postWithAuth, getWithAuth } from '../../Basic/HttpService';

export const getPostCodeDetails = async (val) => {
    let res = await getWithAuth(`Address/${val}`);
    return res;
};
